import { put, takeEvery } from 'redux-saga/effects'
import { createBrowserHistory } from 'history'

import { push } from 'connected-react-router'
import { appConfig } from '../../config'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import {
    FETCH_FEEDBKDETAILS_INIT_ACTION,
    FETCH_FEEDBKDETAILS_SUCCESS_ACTION,
    FETCH_FEEDBKDETAILS_FAIL_ACTION
} from './action'

var history = createBrowserHistory()

function* fetchFeedbackList() {
  const token = localStorage.getItem('token');
  try {
    const res = yield fetch(`${appConfig.ip}userFeedbacks`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
         Authorization: `Bearer ${token}`
      }
    })
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json()
      yield put({
        type: FETCH_FEEDBKDETAILS_SUCCESS_ACTION,
        payload: resJSON
      })
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_FEEDBKDETAILS_FAIL_ACTION, error: err })
    } else {
    }
  }
}

export function* feedbackActionWatcher() {
  yield takeEvery(FETCH_FEEDBKDETAILS_INIT_ACTION, fetchFeedbackList)
}